import { useQuery } from '@tanstack/react-query';
import { UseQueryOptions } from '@tanstack/react-query';
import { ServiceService } from '../service.service';

type UseGetServicesOptions = Omit<
	UseQueryOptions<Array<Services.Service>, Error>,
	'queryKey' | 'queryFn'
> & {
	/** Filtros enviados como query string em GET /services. */
	filters?: Services.GetServicesListParams;
};

export const useGetServices = (options?: UseGetServicesOptions) => {
	const { filters, ...queryOptions } = options ?? {};
	return useQuery({
		queryKey: ['services', filters],
		queryFn: () => ServiceService.get(filters),
		refetchOnWindowFocus: false,
		...queryOptions,
	});
};

export const useGetService = (
	id: string,
	options?: Omit<
		UseQueryOptions<Services.Service, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['service', id],
		queryFn: () => ServiceService.getById(id),
		refetchOnWindowFocus: false,
		...options,
	});
};

/** Tabela pública de repasse ao profissional (GET /services/repasse-table). */
export const useGetRepasseTable = (
	options?: Omit<
		UseQueryOptions<Array<Services.RepasseItem>, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['services', 'repasse-table'],
		queryFn: () => ServiceService.getRepasseTable(),
		refetchOnWindowFocus: false,
		...options,
	});
};

export const useGetServiceByServiceName = (
	serviceName: string,
	options?: Omit<
		UseQueryOptions<Services.Service, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: ['service', serviceName],
		queryFn: () => ServiceService.getByServiceName(serviceName),
		refetchOnWindowFocus: false,
		...options,
	});
};
